import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class JobDetailMenuItem extends Component {
  static propTypes = {
    menuItem: PropTypes.shape({
      name: PropTypes.string.isRequired,
      sectionKey: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
      visible: PropTypes.bool.isRequired,
      iconClassName: PropTypes.string.isRequired,
    }).isRequired,
    onSelectMenuItem: PropTypes.func.isRequired,
  };

  static defaultProps = {
    enabled: true,
    active: false,
  }

  render() {
    const {
      menuItem: {
        name,
        iconClassName,
        active,
        visible,
        sectionKey,
      },
    } = this.props;

    const menuItemClassName = classnames({
      job_details__menu__item: true,
      'job_details__menu__item--active': active,
    });

    const finalIconClassName = classnames({
      fa: true,
      [iconClassName]: true,
      'fa-2x': true,
      job_details__menu__icon: true,
    });

    if (!visible) {
      return null;
    }

    return (
      <div
        className={menuItemClassName}
        onClick={() => this.props.onSelectMenuItem(sectionKey)}
      >
        <i
          className={finalIconClassName}
          alt={name}
        />
        {name}
      </div>
    );
  }
}
